import React from 'react'
import Layout from './Layout'
import ServiceUnit from '../../components/User/ServiceUnit/index'

export default function ServiceUnitPage() {
  return (
   <Layout><ServiceUnit /></Layout>
  )
}
